export const mapObjectionsToUi = (data) => {
    let objectionsData = {};
    let objections = data?.filter(
        (item) => item?.type === "objections" && item?.attributes?.resolved === false
    );
    let sections = data?.filter((item) => item?.type === "sections");
    let items = data?.filter((item) => item?.type === "items");
    for (let i = 0; i < objections?.length; i++) {
        let section = sections?.filter(
            (item) => +item?.id === objections[i]?.attributes?.sectionId
        )[0];
        let item = items?.filter((item) => +item?.id === objections[i]?.attributes?.itemId)[0];
        objectionsData = {
            ...objectionsData,
            [section?.attributes?.name]: {
                ...objectionsData[section?.attributes?.name],
                [item?.attributes?.name]: objections[i]?.attributes?.description,
            },
        };
    }
    return objectionsData;
};
